import styled from 'styled-components';

import { PrimaryInverseButton } from 'components/Input/Button/Button.styles';
import { TertiaryInverseIconButton } from 'components/Input/IconButton/IconButton.styles';

export const StyledHeaderContainer = styled.div`
  background-color: ${({ theme }) => theme.background.medium};
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: sticky;
  height: ${({ theme }) => theme._ui.chatPanel.heightHeader};
  min-height: ${({ theme }) => theme._ui.chatPanel.heightHeader};
  max-height: ${({ theme }) => theme._ui.chatPanel.heightHeader};
  padding: 0 ${({ theme }) => theme.spacing.md};
  gap: ${({ theme }) => theme.spacing.md};

  top: 0;
  z-index: ${({ theme }) => theme._ui.chatPanel.zIndex};

  @media (max-width: ${({ theme }) => theme.breakpoint.sm}) {
    min-height: ${({ theme }) => theme.spacing['7Xl']};
  }
`;

export const StyledMainContentWrapper = styled.div<{ $hideEndChat?: boolean }>`
  display: grid;
  place-content: center;
  flex: 1 2 auto;
  margin-right: ${({ theme }) => theme.spacing.md};
  justify-content: ${({ $hideEndChat }) => ($hideEndChat ? 'center' : 'flex-start')};
`;

export const StyledAvatarWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 100%;
  h2 {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
`;

export const StyledAvatarImage = styled.div`
  display: grid;
  margin-right: ${({ theme }) => theme.spacing.md};
  place-content: center;
`;

export const StyledIconWrapper = styled(TertiaryInverseIconButton).attrs({
  size: 'small',
})`
  height: 40px;
  width: 40px;
  padding: ${({ theme }) => theme.spacing.md};
`;

export const StyledEndChatButton = styled(PrimaryInverseButton).attrs({ size: 'xs' })`
  ${({ theme }) => theme.label.sm}
  min-width: fit-content;
  margin: auto 0;
  border-radius: ${({ theme }) => theme.borderRadius.md};
`;
